const setSelectedFolderIdAction = ({ commit }, payload) => {
  commit('setSelectedFolderId', payload)
}

const setSelectedTabAction = ({ commit }, payload) => {
  commit('setSelectedTab', payload)
}

const setSelectedSlideIdsAction = ({ commit }, payload) => {
  commit('setSelectedSlideIds', payload)
}

const setSelectedSortCriteriaAction = ({ commit }, payload) => {
  commit('setSelectedSortCriteria', payload)
}

export default {
  setSelectedTabAction,
  setSelectedFolderIdAction,
  setSelectedSlideIdsAction,
  setSelectedSortCriteriaAction,
}
